module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_path.js
// module id = 570
// module chunks = 12 13